export default function handler(req, res) {
    if (req.method === 'POST') {
        const { username, password } = req.body;
        
        // Fetch from .env.local, or use default for now
        const validUser = process.env.ADMIN_USER || 'admin';
        const validPass = process.env.ADMIN_PASS || 'BimAdmin123';

        if (username === validUser && password === validPass) {
            return res.status(200).json({ token: 'secure-bim-admin-token-9988' });
        } else {
            return res.status(401).json({ error: 'Invalid username or password' });
        }
    }
    return res.status(405).json({ error: 'Method not allowed' });
}
